<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m" style="display: flex; justify-content: space-between">
                <div>
                    <img :src="img" alt="" class="img-thumbnail" style="width: 135px; height: 125px;">
                </div>
                <div>
                    <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                    <h2 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h2>
                    <div style="font-size: 13px;">
                        <b>{{$t('address')}}៖ </b>
                        {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
                    </div>
                    <div style="font-size: 13px;">
                        <b>{{$t('phone_contact')}}</b>
                        {{company.Phone}} <span>{{$t('email')}}</span>: {{company.Email}}
                        <br>
                        លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
                    </div>
                </div>
            </div>
            <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
            <div class="print-header font-m">
                <h3 class="text-center" style="font-weight: bold;">{{$t('tax_invoice')}}</h3>
                <h3 class="text-center" style="font-weight: bold;">Tax Invoice</h3>
            </div>
            <div class="row" style="margin-bottom: 40px">
                <div class="col-sm-6">
                    <table class="table-print">
                        <tbody>
                        <tr>
                            <th style="width: 200px;">អតិថិជន<br>Customer Name</th>
                            <td class="v-top" style="width: 15px;">:</td>
                            <td class="v-top">{{customer.Name}}</td>
                        </tr>
                        <tr>
                            <th style="width: 200px;">
                                អាស័យដ្ឋាន<br>Address
                            </th>
                            <td class="v-top" style="width: 15px;">:</td>
                            <td class="v-top">{{customer.Address}}</td>
                        </tr>
                        <tr>
                            <th style="width: 200px;">លេខទូរស័ព្ទ<br>Phone</th>
                            <td class="v-top" style="width: 15px;">:</td>
                            <td class="v-top">{{customer.Phone}}</td>
                        </tr>
                        <tr>
                            <th style="width: 200px;">លេខអត្តសញ្ញាណកម្មអតប​(VATTIN)</th>
                            <td style="width: 15px;">:</td>
                            <td>{{customer.TinHead}}-{{customer.VatTin}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table class="table-print" align="right">
                        <tbody>
                        <tr>
                            <th style="width: 120px; text-align: right">លេខរៀងវិក្កយបត្រ</th>
                            <td style="width: 15px;">:</td>
                            <td>{{invoice.Num}}</td>
                        </tr>
                        <tr>
                            <th style="width: 120px; text-align: right">កាលបរិច្ឆេទចេញវិក្កយបត្រ</th>
                            <td>:</td>
                            <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                        </tr>
                        <tr>
                            <th style="width: 140px; text-align: right">កាលបរិច្ឆេទបញ្ជូលទំនិញ</th>
                            <td>:</td>
                            <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
                        </tr>
                        <tr>
                            <th style="width: 120px; text-align: right">សាខា /Branch</th>
                            <td>:</td>
                            <td>សៀមរាប</td>
                        </tr>
                        <tr>
                            <th style="width: 120px; text-align: right">PO Order Ref No.</th>
                            <td></td>
                            <td>{{invoice.RefNum}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr class="text-center">
                                <th style="width: 50px;">{{$t('no')}} No</th>
                                <th>លេខកូដ <br>Barcode No </th>
                                <th>បរិយាយ <br> Description of Goods </th>
                                <th style="width: 100px;">{{$t('qty')}} <br> QTY</th>
                                <th style="width: 100px;">{{$t('uom')}} <br> UOM</th>
                                <th style="width: 100px;">{{$t('unit_price')}} <br> Unit Price</th>
                                <th style="width: 100px;">{{$t('sub_total')}} <br> Amount</th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr v-for="(ret,index) in lines" :key="ret.Id">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Quantity}}</td>
                                <td>{{ret.UomName}}</td>
                                <td>{{$dollar(ret.Price)}}</td>
                                <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="6" class="text-right">សរុប / Total:</td>
                                <td style="width: 120px;" class="text-right">{{$dollar(invoice.GrandTotal)}}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">អាករលើតម្លៃបន្ថែម VAT (10%):</td>
                                <td style="width: 120px;" class="text-right">{{$dollar(invoice.TaxVat)}}</td>
                            </tr>
                            <tr>
                                <td colspan="6" style="width: 150px;" class="text-right">សរុបរួម​/ Grand Total:</td>
                                <td class="text-right">$  {{$dollar(invoice.TotalAmount)}}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">អត្រាប្តូរប្រាក់ប្រចាំថ្ងៃ:</td>
                                <td class="text-right">R  {{$money(invoice.ExchangeRate)}}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">ចំនួនទឹកប្រាក់ជាលុយរៀល:</td>
                                <td class="text-right">R  {{$money(invoice.TotalAmount*invoice.ExchangeRate)}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="footer" style="margin-top: 30%">
            <div style="display: flex; justify-content: space-between">
                <div>
                    <div style="border: 1px solid black;
                                background: black;
                                height: 2px;
                                width: 200px;
                                margin-bottom: 10px"
                    ></div>
                    <p style="margin-left: 20px">ហត្តលេខា​និងឈ្មោះអ្នកទិញ</p>
                    <p style="margin-left: 10px">Customer's Signature & Name</p>
                    <p>សម្គាល់៖​ច្បាប់ដើមសម្រាប់អ្នកទិញ ច្បាប់ចម្លងសម្រាប់អ្នកលក់</p>
                    <p>Note: Original Invoice for customer, Copies Invoice for seller.</p>
                </div>
                <div class="text-center">
                    <div style="border: 1px solid black;
                                background:
                                black; height: 2px;
                                width: 200px;
                                margin-bottom: 10px"
                    ></div>
                    <p>ហត្តលេខា​និងឈ្មោះអ្នកលក់</p>
                    <p>Seller's Signature & Name</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "TaxInvoice",
        data() {
            return {
                customer: {},
                company: {},
                invoice: {
                    IsApproved: true
                },
                lines: [],
                img: '/img/company-logo.png',
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                    if(this.company.Logo != null){
                        this.img = this.$base() + 'image/logo/' + this.company.Logo;
                    }
                });
            },
            findById(){
                let id = this.$route.params.id;
                if(id != undefined && id != null && id != ''){
                    let loading = this.$loading.show();
                    this.$api().post('sale/invoice/find', { Id: id }).then(res => {
                        var data = res.data.Data;
                        this.invoice = data.SaleInvoice;
                        this.customer = res.data.Json.Customer;
                        this.lines = data.SaleInvoiceLines;
                    }).finally(function(){ loading.hide(); });
                }
            }
        }
    }
</script>
